import {BaseEntity, IBaseEntity} from 'app/blocks/model/base-entity.model';
import {IRoute} from 'app/blocks/model/route.model';

export interface ITerritory extends IBaseEntity {
    id?: number;
    name?: string;
    polygonBoundary?: object;
    defaultRoute?: IRoute;
}

export class Territory extends BaseEntity implements ITerritory {
    public id?: number;
    public name?: string;
    // public polygonBoundary?: object;
    public defaultRoute?: IRoute;
    public postCodePrefixes?: any[];

    constructor(territory?) {
        super();

        if (territory) {
            this.id = territory.id;
            this.name = territory.name;
            // this.polygonBoundary = territory.polygonBoundary;
            this.defaultRoute = territory.defaultRoute;
            this.postCodePrefixes = territory.postCodePrefixes;
        }
    }

    get discriminator(): any {
        return this.id;
    }

    clone(): Territory {
        return new Territory(this);
    }
}
